import * as React from "react";

import { useFormikContext } from "formik";

import { Box, Checkbox, FormControlLabel, TextField } from "@mui/material";

import type { FormikInitialValuesNewRequest } from "../../../model/form.model";

export function ObservationStepMobile() {
  const { values, setFieldValue, handleBlur } = useFormikContext<
    FormikInitialValuesNewRequest
  >();

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <TextField
        label="Observação"
        name="observation.observationNote"
        value={values.observation.observationNote}
        onChange={(e) =>
          setFieldValue("observation.observationNote", e.target.value)
        }
        onBlur={handleBlur}
        multiline
        minRows={6}
        fullWidth
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={values.observation.commentsInInvoice}
            onChange={(e) =>
              setFieldValue("observation.commentsInInvoice", e.target.checked)
            }
          />
        }
        label="Incluir observação na nota fiscal"
      />
    </Box>
  );
}
